import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RelativeTimePipe } from '@shared/pipes/relative-time.pipe';
import { IUserDevice } from '@user/models/user-device';

@Component({
	selector: 'app-user-device-card',
	imports: [CommonModule, RelativeTimePipe],
	templateUrl: './user-device-card.component.html',
	styleUrl: './user-device-card.component.scss',
})
export class UserDeviceCardComponent {
	@Input() device: IUserDevice;
	@Input() currentDeviceId: string;
	@Output() remove = new EventEmitter<IUserDevice>();

	get isCurrentDevice(): boolean {
		return this.device.deviceId === this.currentDeviceId;
	}

	onRemove(): void {
		this.remove.emit(this.device);
	}
}
